import React from 'react';
import PropTypes from 'prop-types';
import TreeRow from './TreeRow';
import { translate } from 'helpers/translateHelper';
import { map } from 'lodash';
import { IconPowertrainGroup } from 'svgIcons/MotionPortalIcons';
import PowertrainNode from './PowertrainNode';
import IconSingleAssets from 'svgIcons/MotionPortalIcons/IconSingleAssets';
import AssetNode from './AssetNode';
import { useNodeExpansion } from './HierarchyExpansionContext';

const UnassignedNode = ({
    unAssignedNode,
    depth,
    selectedAsset,
    onSelectAsset,
    condition,
    isForSingleAsset,
    leftPanelSize,
    allAssets,
    nodeId,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const { expanded, toggle } = useNodeExpansion(nodeId);
    const hasSelectionDot = !!selectionNodeIds?.has(nodeId);

    return (
        <>
            <TreeRow
                depth={depth}
                icon={isForSingleAsset ? <IconSingleAssets /> : <IconPowertrainGroup />}
                label={isForSingleAsset ?
                    translate('ABB.Powertrain.Frontend.singleAssetsLabel')
                    : translate('ABB.Powertrain.Frontend.powertrainsNotInHierarchy')
                }
                count={unAssignedNode?.length}
                hasChildren={(unAssignedNode?.length || 0) > 0}
                condition={condition}
                isExpanded={expanded}
                onToggle={toggle}
                hasSelectionDot={hasSelectionDot}
                descriptionText={isForSingleAsset ?
                    translate('ABB.Powertrain.Frontend.assetsNotYetInAPowertrain')
                    : translate('ABB.Powertrain.Frontend.powertrainsNotYetInALocationGroup')
                }
            />
            {expanded &&
                <>
                    {isForSingleAsset ?
                        map(unAssignedNode, (asset, index) =>
                            <AssetNode
                                key={asset?.assetId}
                                depth={depth}
                                index={index}
                                selectedAsset={selectedAsset}
                                asset={asset}
                                allAssets={allAssets}
                                onSelectAsset={onSelectAsset}
                                leftPanelSize={leftPanelSize}
                                selectionNodeIds={selectionNodeIds}
                                selectedAssetSignalCounts={selectedAssetSignalCounts}
                            />)
                        : map(unAssignedNode, powertrain =>
                            <PowertrainNode
                                key={powertrain?.powertrainId}
                                powertrain={powertrain}
                                depth={depth + 1}
                                selectedAsset={selectedAsset}
                                onSelectAsset={onSelectAsset}
                                leftPanelSize={leftPanelSize}
                                allAssets={allAssets}
                                selectionNodeIds={selectionNodeIds}
                                selectedAssetSignalCounts={selectedAssetSignalCounts}
                            />
                        )}
                </>
            }
        </>
    );
};

UnassignedNode.propTypes = {
    unAssignedNode: PropTypes.array.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    condition: PropTypes.string,
    isForSingleAsset: PropTypes.bool,
    leftPanelSize: PropTypes.number,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    allAssets: PropTypes.array,
    nodeId: PropTypes.string,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default UnassignedNode;
